import Component from './Component';
import React from 'react';

export default class Loader extends Component {

	static propTypes = {
		visible: React.PropTypes.bool
	};

	static defaultProps = {
		visible: false,
		img: __MOBILE__ ? 'img/ajax-loader.gif' : '/img/ajax-loader.gif'
	};

	constructor(props) {
		super(props);
		this.state = {visible: props.visible};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.visible && !this.props.visible) {
			this.timeout = setTimeout(() => {
				if (false && __MOBILE__) {
					window.plugins.spinnerDialog.show('Načítám data ...', null, true);
				}
				this.setState({visible: true});
			}, 400);
		}
		else {
			if (nextProps.visible == false) {
				if (this.timeout) {
					clearTimeout(this.timeout);
				}
				if (__MOBILE__) {
					window.plugins.spinnerDialog.hide();
				}
				this.state.visible = nextProps.visible;
			}
		}
	}

	render() {
		if (!this.state.visible) {
			return false;
		}

		return (
			<span>
				<div style={{background:'#E5E5E5', zIndex:99, opacity:0.25, position:'absolute', top: 60, width: '100%', bottom: 0}}>
				</div>
				<div style={{position:'absolute', zIndex:101, top: '50%', left: '50%', width: 32, height:32, bottom: 0}}>
					<img src={this.props.img} />
				</div>
			</span>
		)
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-datagrid/src/Loader.js